import { render, staticRenderFns } from "./quick-order-switch.vue?vue&type=template&id=10b634aa&scoped=true&"
import script from "./quick-order-switch.vue?vue&type=script&lang=js&"
export * from "./quick-order-switch.vue?vue&type=script&lang=js&"
import style0 from "./quick-order-switch.vue?vue&type=style&index=0&id=10b634aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b634aa",
  null
  
)

export default component.exports